/* eslint-disable  @typescript-eslint/no-explicit-any */

import Vue from 'vue'
import Vuex, { ActionContext } from 'vuex'

import loadingbar from './loadingbar'

Vue.use(Vuex)

const config: any = {
  strict: false,
  modules: {
    loadingbar,
  },
};

export enum Types {
  CLEAR = 'clear',
}

export interface State {
  status: false;
}

export default new Vuex.Store({
  ...config,
  actions: {
    async clear(store: ActionContext<State, any>): Promise<void> {
      for (const moduleName in config.modules) {
        if (Object.prototype.hasOwnProperty.call(config.modules[moduleName].actions, 'clear')) {
          store.commit(`${moduleName}/${Types.CLEAR}`);
        }
      }
    },
  },
});
